// Auto generated file, do not manually modify!
// com.hotpads.googlemaps.web.handler.GoogleMapsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { GoogleMapsWebApiHandler_addSignatureAndKeyToUrl } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GoogleMapsAddSignatureAndKeyToUrlRequestDto,
  GoogleMapsAddSignatureAndKeyToUrlResponseDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

export interface GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Args {
  postData: GoogleMapsAddSignatureAndKeyToUrlRequestDto;
}

export type GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Options = UseMutationOptions<
  GoogleMapsAddSignatureAndKeyToUrlResponseDto,
  unknown,
  GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Args
>;

/**
 * Add GoogleMap signature and key to URL
 */
export const useGoogleMapsWebApiHandler_addSignatureAndKeyToUrl = ({
  httpClient,
  ...options
}: Omit<GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: GoogleMapsWebApiHandler_addSignatureAndKeyToUrl_Args) =>
      GoogleMapsWebApiHandler_addSignatureAndKeyToUrl(args.postData, httpClient),
  });
};
